// ─── Theme tokens ──────────────────────────────────────────────────────
// Every key resolves to a CSS custom property defined in
// `styles/colors_and_type.css`. Theme switching is a single attribute write
// on <html data-theme="dark|light"> — the var() lookups in this object
// automatically pick up the new palette without any component re-render.
//
// The accent key falls back to --accent-override so the Tweaks panel's
// color picker still wins (see App.jsx — it sets that var on :root).

export const C = {
  app:     'var(--bg-app)',
  bar:     'var(--bg-sidebar)',
  surface: 'var(--bg-surface)',
  raised:  'var(--bg-raised)',
  input:   'var(--bg-input)',
  border:        'var(--border)',
  borderSubtle:  'var(--border-subtle)',
  borderStrong:  'var(--border-strong)',
  borderDashed:  'var(--border-dashed)',
  fg1: 'var(--fg-1)',
  fg2: 'var(--fg-2)',
  fg3: 'var(--fg-3)',
  fg4: 'var(--fg-4)',
  fg5: 'var(--fg-5)',
  fg6: 'var(--fg-6)',
  accent:        'var(--accent-override, var(--accent))',
  accentStrong:  'var(--accent-strong)',
  accentDeep:    'var(--accent-deep)',
  accentSoft:    'var(--accent-soft)',
  accentBright:  'var(--accent-bright)',
  accentMuted:   'var(--accent-muted)',
  ok:    'var(--ok-fg)',
  warn:  'var(--warn-fg)',
  error: 'var(--error-fg)',
};

export default C;
